import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, message, Tag, Image, Switch, Upload } from 'antd';
import { SearchOutlined, AuditOutlined, UploadOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph } = Typography;
const Hyxzj = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [formtx] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [opentx, setOpentx] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的信息
  const [czmsg, setczmsg] = useState([]);// 选择的信息
  const [ticks, setticks] = useState([]);


  useEffect(() => {
    async function getau() {
      const res = await request.post('/hyxzj_list')
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const gotx = (t) => {
    setczmsg(t)
    formtx.setFieldsValue({ dbno: t.key, lsh: '' });// 回传发送短信订单号码
    setOpentx(true)
  }

  const gocz = (v) => {
    setccpxx(v)
    formxf.setFieldsValue({ dbno: v.key, lsh: '' });// 回传发送短信订单号码
    setOpen(true)
  }


  const onFxfsq = async (e) => {
    const rq = await request.post('/hyxzj', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }

  const token = localStorage.getItem('token_key')

  const props = {
    name: 'file',
    action: 'http://api.ddspp.com:30123/v3/hyxtx',
    headers: {
      Authorization: `{"Bearer_ddspp":"${token}"}`,
    },
    data: { ddno: czmsg.key },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        //  console.log(info.fileList[0].response.return_msg);//info.file, 
      }
      if (info.file.status === 'done') {

        setOpentx(false)
        setticks(info.fileList[0].response.ticks)
        // console.log(info.fileList[0].response.return_code);
        message.success(`${info.fileList[0].response.return_msg}`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };





  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {record.uto === "CZ" && <Tag color="green" onClick={() => gocz(record)}><AuditOutlined />充值审核</Tag>}
          {record.uto === "TX" && <Tag color="purple" onClick={() => gotx(record)}><AuditOutlined />提现处理</Tag>}
        </Space>
      ),
    },
    {
      title: '金额',
      dataIndex: 'bdamount',
      key: 'bdamount',
      ...getColumnSearchProps('bdamount'),
    },
    {
      title: '用途',
      dataIndex: 'uto',
      key: 'uto',
      ...getColumnSearchProps('uto'),
      render: (_, record) => (
        <Space size="middle">
          {record.uto === "CZ" && <Tag color="green" >充值</Tag>}
          {record.uto === "TX" && <Tag color="red">提现</Tag>}
        </Space>
      ),
    },
    {
      title: '凭据截图',
      key: 'pj',
      render: (_, record) => (
        <Space size="middle">
          {record.uto === "CZ" && <Image width={80}
            src={`data:${record.pjjson[0].type};base64,${record.pjjson[0].basenr}`}
            preview={{
              src: `data:${record.pjjson[0].type};base64,${record.pjjson[0].basenr}`,
            }}
          />}
        </Space>
      ),
    },

  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table columns={columns} dataSource={bangm} size="small" />

          </Form>



        </div>


        <Modal
          // title="数据修复申请表"
          footer={null}
          centered
          open={open}
          onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph> 金额：{ccpxx.bdamount} </Paragraph>

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >

            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.Item label="交易流水号" name='lsh'>
              <Input />
            </Form.Item>
            <Form.Item label="处理意见" name='clyj' rules={[{ required: true, message: '请选择处理意见!' },]}>
              <Switch checkedChildren="金额一致" unCheckedChildren="金额错误" />
            </Form.Item>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                提          交
              </Button>
            </Form.Item>


          </Form>
        </Modal>




        <Modal
          title="提现处理"
          footer={null}
          centered
          open={opentx}
          onOk={() => onFxfsq()}
          onCancel={() => setOpentx(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph> 金额：{czmsg.bdamount} </Paragraph>
          {czmsg.pjjson && <><Paragraph> 开户名称：{czmsg.pjjson[0].kname}</Paragraph>
            <Paragraph> 开户行：{czmsg.pjjson[0].khh} </Paragraph>
            <Paragraph> 账号：{czmsg.pjjson[0].knum} </Paragraph></>
          }




          <Form
            name="formtx"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formtx}
          >


            <Form.Item label="上传凭证">
              <Upload {...props} >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Upload>
            </Form.Item>





          </Form>
        </Modal>





      </ConfigProvider>
    </>

  );
};
export default Hyxzj;